const base = '/v1/partner';

export const partnerApiPath = {
  getMe: `${base}/me`,
  getMeProfile: `${base}/me/profile`,
  getBrands: `${base}/brands`,
  getBrandProductsSearch: (brandId: string) => `${base}/brands/${brandId}/products/search`,
  postBrandProductsOptions: (brandId: string) => `${base}/brands/${brandId}/products/options`,
  getBrandProductsColorGroup: (brandId: string) => `${base}/brands/${brandId}/products/color-group`,
  postCampaign: `${base}/campaigns`,
  deleteCampaign: (campaignId: number | string) => `${base}/campaigns/${campaignId}`,
  updateCampaignStatus: (campaignId: number | string) => `${base}/campaigns/${campaignId}/status`,
  getRecruitmentCampaigns: `${base}/campaigns/seeding/recruitment`,
  getRecruitmentCampaignsCount: `${base}/campaigns/seeding/recruitment/count`,
  getProposalCampaigns: `${base}/campaigns/seeding/proposal`,
  getProposalCampaignsCount: `${base}/campaigns/seeding/proposal/count`,
  getCampaignSeedingDetail: (campaignId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}`,
  getSeedingAnnouncementDate: `${base}/campaigns/seeding/announcement-date`,
  updateSeedingCampaign: (campaignId: number | string) => `${base}/campaigns/seeding/${campaignId}`,
  getCampaignSeedingStatusCounts: (campaignId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}/participations/status-counts`,
  getCampaignSeedingApplicants: (campaignId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}/applicants`,
  getCampaignSeedingApplicantsCount: (campaignId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}/applicants/count`,
  getCampaignSeedingParticipations: (campaignId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}/participations`,
  getParticipationSelectedOptions: (
    campaignId: number | string,
    participationId: number | string,
  ) => `${base}/campaigns/seeding/${campaignId}/participations/${participationId}/selected-options`,
  getCuratorTaxInfo: (campaignId: number | string, participationId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}/participations/${participationId}/tax-info`,
  seedingTermsAgreement: `${base}/seeding/terms-agreement`,
  getCampaignResults: (campaignId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}/results`,
  getCampaignResultCounts: (campaignId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}/results/count`,
  postSeedingProposals: (campaignId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}/proposals`,
  proposeSeedingCurators: (campaignId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}/proposals`,
  selectSeedingCurators: (campaignId: number | string) =>
    `${base}/campaigns/seeding/${campaignId}/selections`,
  postSeedingEvaluation: `${base}/seeding/evaluations`,
  getSeedingEvaluation: (seedingParticipationId: number | string) =>
    `${base}/seeding/evaluations/${seedingParticipationId}`,
  curatorWishlist: (curatorId: string) => `${base}/curators/${curatorId}/wishlist`,
  getCurators: `${base}/curators`,
  getCuratorsCount: `${base}/curators/count`,
  getCuratorCategories: `${base}/curators/categories`,
} as const;
